import {
  ApiActivityTag as ActivityTags,
  type ApiActivityTag,
} from '@repo/api-kit/transfers-api-v4';

// oxlint-disable-next-line typescript/consistent-type-assertions
export const ACTIVITY_TAGS = Object.fromEntries(
  Object.entries(ActivityTags)
    .filter(([key]) => key !== 'ACTIVITY_TAG_UNSPECIFIED')
    .map(([key, value]) => [key.toUpperCase(), value])
) as {
  readonly [K in Exclude<
    keyof typeof ActivityTags,
    'ACTIVITY_TAG_UNSPECIFIED'
  > as Uppercase<K>]: (typeof ApiActivityTag)[K];
};

export type ActivityTag = Exclude<keyof typeof ApiActivityTag, 'ACTIVITY_TAG_UNSPECIFIED'>;

export const RULES_ENGINE_FIRST_TIME_EXPERIENCE_HAS_SEEN =
  'RULES_ENGINE_FIRST_TIME_EXPERIENCE_HAS_SEEN';

export const {
  ATM,
  FEES,
  FINANCE,
  FOOD_AND_GROCERY,
  GAS_STATION,
  HARDWARE_AND_EQUIPMENT,
  HOTEL_AND_LODGING,
  INSURANCE,
  IT_AND_ELECTRONICS,
  LEGAL_AND_ACCOUNTING,
  LOGISTICS,
  MANUFACTURING,
  MARKETING,
  OFFICE_RENTAL,
  OFFICE_SUPPLY,
  ONLINE_SERVICE,
  OTHER_EXPENSE,
  OTHER_INCOME,
  OTHER_SERVICE,
  REFUND,
  RESTAURANT_AND_BAR,
  SALARY,
  SALES,
  SUBSCRIPTION,
  TAX,
  TRANSPORT,
  TREASURY_AND_INTERCO,
  UTILITY,
  VOUCHER,
  DIRECT_DEBIT_HOLD,
} = ACTIVITY_TAGS;

export const CATEGORIES = {
  codes: [
    ATM,
    FEES,
    FINANCE,
    FOOD_AND_GROCERY,
    GAS_STATION,
    HARDWARE_AND_EQUIPMENT,
    HOTEL_AND_LODGING,
    INSURANCE,
    IT_AND_ELECTRONICS,
    LEGAL_AND_ACCOUNTING,
    LOGISTICS,
    MANUFACTURING,
    MARKETING,
    OFFICE_RENTAL,
    OFFICE_SUPPLY,
    ONLINE_SERVICE,
    OTHER_EXPENSE,
    OTHER_INCOME,
    OTHER_SERVICE,
    REFUND,
    RESTAURANT_AND_BAR,
    SALARY,
    SALES,
    SUBSCRIPTION,
    TAX,
    TRANSPORT,
    TREASURY_AND_INTERCO,
    UTILITY,
    VOUCHER,
  ],
  Card: [
    ATM,
    FINANCE,
    FOOD_AND_GROCERY,
    GAS_STATION,
    HARDWARE_AND_EQUIPMENT,
    HOTEL_AND_LODGING,
    INSURANCE,
    IT_AND_ELECTRONICS,
    LEGAL_AND_ACCOUNTING,
    LOGISTICS,
    MANUFACTURING,
    MARKETING,
    OFFICE_RENTAL,
    OFFICE_SUPPLY,
    ONLINE_SERVICE,
    OTHER_EXPENSE,
    OTHER_SERVICE,
    REFUND,
    RESTAURANT_AND_BAR,
    SALARY,
    TAX,
    TRANSPORT,
    UTILITY,
  ],
  DirectDebit: [
    FINANCE,
    FOOD_AND_GROCERY,
    GAS_STATION,
    HARDWARE_AND_EQUIPMENT,
    HOTEL_AND_LODGING,
    INSURANCE,
    IT_AND_ELECTRONICS,
    LEGAL_AND_ACCOUNTING,
    LOGISTICS,
    MANUFACTURING,
    MARKETING,
    OFFICE_RENTAL,
    OFFICE_SUPPLY,
    ONLINE_SERVICE,
    OTHER_EXPENSE,
    OTHER_SERVICE,
    REFUND,
    RESTAURANT_AND_BAR,
    SALARY,
    TAX,
    TRANSPORT,
    TREASURY_AND_INTERCO,
    UTILITY,
  ],
  Income: [OTHER_INCOME, REFUND, SALES, TREASURY_AND_INTERCO],
  FinancingIncome: [OTHER_INCOME],
  Check: [OTHER_INCOME, REFUND, SALES, TREASURY_AND_INTERCO],
  Other: [
    FINANCE,
    FOOD_AND_GROCERY,
    GAS_STATION,
    HARDWARE_AND_EQUIPMENT,
    HOTEL_AND_LODGING,
    INSURANCE,
    IT_AND_ELECTRONICS,
    LEGAL_AND_ACCOUNTING,
    LOGISTICS,
    MANUFACTURING,
    MARKETING,
    OFFICE_RENTAL,
    OFFICE_SUPPLY,
    ONLINE_SERVICE,
    OTHER_EXPENSE,
    OTHER_SERVICE,
    RESTAURANT_AND_BAR,
    SALARY,
    TAX,
    TRANSPORT,
    TREASURY_AND_INTERCO,
    UTILITY,
  ],
  Transfer: [
    FINANCE,
    FOOD_AND_GROCERY,
    GAS_STATION,
    HARDWARE_AND_EQUIPMENT,
    HOTEL_AND_LODGING,
    INSURANCE,
    IT_AND_ELECTRONICS,
    LEGAL_AND_ACCOUNTING,
    LOGISTICS,
    MANUFACTURING,
    MARKETING,
    OFFICE_RENTAL,
    OFFICE_SUPPLY,
    ONLINE_SERVICE,
    OTHER_EXPENSE,
    OTHER_SERVICE,
    RESTAURANT_AND_BAR,
    SALARY,
    TAX,
    TRANSPORT,
    TREASURY_AND_INTERCO,
    UTILITY,
  ],
  PagopaPayment: [OTHER_EXPENSE, OTHER_SERVICE, TAX, UTILITY],
  DirectDebitCollection: [OTHER_INCOME, REFUND, SALES, TREASURY_AND_INTERCO],
  DirectDebitCollectionRTransaction: [
    FINANCE,
    FOOD_AND_GROCERY,
    GAS_STATION,
    HARDWARE_AND_EQUIPMENT,
    HOTEL_AND_LODGING,
    INSURANCE,
    IT_AND_ELECTRONICS,
    LEGAL_AND_ACCOUNTING,
    LOGISTICS,
    MANUFACTURING,
    MARKETING,
    OFFICE_RENTAL,
    OFFICE_SUPPLY,
    ONLINE_SERVICE,
    OTHER_EXPENSE,
    OTHER_SERVICE,
    RESTAURANT_AND_BAR,
    SALARY,
    TAX,
    TRANSPORT,
    TREASURY_AND_INTERCO,
    UTILITY,
  ],
  DirectDebitHold: [DIRECT_DEBIT_HOLD],
} as const;
